"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resources = void 0;
const i18next_1 = __importDefault(require("i18next"));
const react_i18next_1 = require("react-i18next");
const json_1 = require("../json");
exports.resources = {
    en: { translation: json_1.en },
    ru: { translation: json_1.ru },
};
i18next_1.default.use(react_i18next_1.initReactI18next).init({
    resources: exports.resources,
    lng: json_1.availableLocales.ru,
    interpolation: { escapeValue: false },
});
exports.default = i18next_1.default;
